import { Link, useParams } from "react-router-dom";
import useAuth from "../../../../../hooks/useAuth";
import MobileForm from "../../../../../components/MobileForm";
import { makeStyles } from '@material-ui/core';
import { Box }  from '@material-ui/core';

const useStyles = makeStyles({
  formButton: {
    width: '30px',
    background: '#6271CB',
    color: 'white',
    borderRadius: 5,
    display: 'block',
    textDecoration: 'none',
    textAlign: 'center',
    paddingTop: 10,
    paddingBottom: 10,
    marginBottom: 7,
    marginLeft: 20,
    marginRight: 20,
  }
});

const ComplianceReportPage1 = () => {
  const styles = useStyles()
  const { version, appointmentId } = useParams();
  const useValidation = require(`./v${version}/useValidation`).default;
  const background = require(`./v${version}/background.png`);
  const fields = require(`./v${version}/fields.json`);
  const { width: bgWidth, height: bgHeight } = require(`./v${version}/dimensions.json`);

  const width = document.documentElement.clientWidth;
  const ratio = width / bgWidth;
  const newHeight = bgHeight * ratio;

  return (
    <div>
      <MobileForm
        type="complianceReportPage1"
        version={version}
        width={width}
        height={newHeight}
        useValidation={useValidation}
        background={background}
        fields={fields}
      />
      <Box display="flex" flexDirection="row">
        <Link to={`/form/compliance-report/${version}/2/${appointmentId}`} className={styles.formButton}>2</Link>
        <Link to={`/form/compliance-report/${version}/3/${appointmentId}`} className={styles.formButton}>3</Link>
      </Box>
    </div>
  );
};

const Page = () => {
  const { PrivateContent } = useAuth();

  return (
    <PrivateContent title="Compliance Report">
      <ComplianceReportPage1 />
    </PrivateContent>
  );
};

export default Page;
